// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Cards_wrapper__ALnIf"};